import React from 'react';
import { withErrorBoundary } from '@wix/da-react-context/pkg/ErrorBoundary/withErrorBoundary';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import JournalFeedCard from './Journal';
import StatusFeedCard from './Status';
import PollFeedCard from './Poll';
import TierFeedCard from './Tier';
import CommissionFeedCard from './Commission';
import type { FeedCardProps } from './types';

const FeedCard: React.FC<FeedCardProps> = props => {
  switch (getDeviationType(props.deviation)) {
    case DeviationTypes.COMMISSION:
      return <CommissionFeedCard {...props} />;
    case DeviationTypes.POLL:
      return <PollFeedCard {...props} />;
    case DeviationTypes.JOURNAL:
      return <JournalFeedCard {...props} />;
    case DeviationTypes.STATUS:
      return <StatusFeedCard {...props} />;
    case DeviationTypes.TIER:
      return <TierFeedCard {...props} />;
    default:
      return null;
  }
};
FeedCard.displayName = 'FeedCard';
export default withErrorBoundary(FeedCard, 'FeedCard');
